export default function SeoArticleTeaser() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 lg:px-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="lg:w-2/5">
            <div className="rounded-3xl overflow-hidden bg-accent-50 p-0">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20closeup%20of%20fashion%20sneaker%20detail%20with%20quality%20inspection%20tag%20attached%20on%20textured%20cream%20paper%20background%20soft%20directional%20window%20light%20creating%20elegant%20shadows%20editorial%20product%20storytelling%20warm%20beige%20and%20ivory%20palette%20sophisticated%20minimal%20aesthetic&width=500&height=600&seq=qcfoto-article-002&orientation=portrait&nocache=true"
                alt="Itaobuy Spreadsheet - Guida SEO"
                title="Guida Itaobuy Spreadsheet"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          <div className="lg:w-3/5">
            <span className="inline-block text-xs font-medium text-primary-600 uppercase tracking-widest mb-3">
              (Guida Itaobuy)
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-5">
              Come usare Itaobuy Sheet <span className="text-foreground-300">al meglio</span>
            </h2>

            <div className="relative pl-6 border-l-2 border-primary-200">
              <p className="text-foreground-600 leading-relaxed text-sm md:text-base mb-4 italic">
                &ldquo;Itaobuy Sheet &egrave; uno strumento essenziale per chi cerca prodotti di qualit&agrave; senza perdere ore in ricerche infinite. Con il nostro spreadsheet aggiornato, puoi navigare tra centinaia di articoli suddivisi per categoria, verificare le foto QC e confrontare i prezzi prima di acquistare. Ogni prodotto &egrave; accompagnato da informazioni dettagliate che ti aiutano a prendere decisioni pi&ugrave; informate e sicure.&rdquo;
              </p>
              <p className="text-xs text-foreground-400 font-medium">
                &mdash; Redazione Itaobuy
              </p>
            </div>

            <div className="flex items-center gap-4 mt-6">
              <a
                href="/guida-itaobuy-spreadsheet"
                className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <span>Leggi l&apos;articolo completo</span>
                <i className="ri-arrow-right-line text-base"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}